export const APP_CONFIG = {
  baseDomain: process.env.VUE_APP_ENDPOINT,
  mediaDomain: 'https://media.uniship.vn',
  authSetting: {
    tokenName: 'token',
  },
  settings: {
    main_domain: 'https://uniship.vn',
    firebase_prefix: 'vbimex',
    firebase_storage: 'https://firebasestorage.googleapis.com/v0/b/vbimex-2022.appspot.com/o'
  },
  eventBusAction: {
    disableMenuLeft: 'disableMenuLeft',
    disableHeader: 'disableHeader',
    showHideMenuLeft: 'showHideMenuLeft',
    reloadWithdrawalHistories: 'reloadWithdrawalHistories',
    reloadNotification: 'reloadNotification'
  },
  stateKey: {
    authStore: 'authStore',
    commonStore: 'commonStore',
    cartState: 'cartState',
    flag: 'flag',
    orderFlag: 'orderFlag',
  },
  sqlDateFormat: 'YYYY-MM-DD hh:mm:ss',
  notifyRefreshTime: 10,
  ORDER_TYPE: {
    order: 1,
    deposit: 2,
    payAuthority: 3,
    transaction: 4,
    quotation: 5,
  },
};
